import { Component } from '@angular/core';

import { LoadingController } from 'ionic-angular';
import { ImageService } from '../../../../services/image.service';
import { NotificationService } from '../../../../services/texting.service';
import { AlertMessager } from '../../../../lib/alertMessager';
import { TextAdvertisement } from '../../../../model/textAdvertisement';
import { RodeoEventService } from '../../../../services/rodeoEvent.service';
import { RodeoService } from '../../../../services/rodeo.service';
import { SearchOptions } from '../../../../model/searchOptions';
import { Rodeo } from '../../../../model/rodeo';

@Component({
    selector: 'admin-texting',
    templateUrl: 'texting.html'
})
export class TextingSection {
    popoverActive: boolean;
    dataLoading: boolean;

    textAdvertisement: TextAdvertisement = new TextAdvertisement();
    emailToo: boolean;
    testingNumber: any;

    rodeoResults: Rodeo[];

    imageFile: any;
    imageUrl: any;

    disciplines: any[] = [];
    estimatedReach: any = null;

    constructor(private textingService: NotificationService, private alertMessager: AlertMessager, 
        private rodeoEventService: RodeoEventService, private loadingControl: LoadingController, 
        private imageService: ImageService, private rodeoService: RodeoService) { 
        this.rodeoEventService.getEventTypes()
        .then(data => {
            this.disciplines = data as string[];
        });

        this.rodeoService.searchRodeos(new SearchOptions())
            .then(data => {
                this.rodeoResults = [];
                Object.assign(this.rodeoResults, data);
            }, error => {
                console.log(error);
            });
    }

    async sendTexts() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        if (!this.estimatedReach)
            await this.getReach();

        let loader = this.loadingControl.create({
            content: 'Sending out ' + this.estimatedReach + ' texts...',
        });

        if (this.imageUrl) {
            this.textAdvertisement.imgUrls = [];
            this.textAdvertisement.imgUrls.push(this.imageUrl);
        }

        loader.present();
        this.textingService.sendTexts(this.textAdvertisement, this.emailToo, this.testingNumber)
            .then((data) => {
                this.popoverActive = false;
                loader.dismiss();
                this.alertMessager.showConfirmation("Success", data + " Texts Successfully Sent");
            }, error => {
                this.popoverActive = false;
                loader.dismiss();
                this.alertMessager.showError("Text Send Error", error);
            })
    }

    async getReach() {
        if (this.dataLoading)
            return;

        this.dataLoading = true;

        let loader = this.loadingControl.create({
            content: 'Updating estimated reach...',
        });
        loader.present();
        await this.textingService.getTextingReach(this.textAdvertisement)
            .then((data) => {
                this.dataLoading = false;
                loader.dismiss();
                this.estimatedReach = data;
            }, error => {
                this.dataLoading = false;
                loader.dismiss();
            })
    }

    logoFileChangeListener($event): void {
        this.imageFile = $event.target.files[0];
        this.uploadLogoFile();
    }

    uploadLogoFile() {
        if (this.popoverActive)
            return;

        let loader = this.loadingControl.create({
            content: 'Uploading Flier...',
        });

        loader.present();
        this.popoverActive = true;
        let fileName = Math.floor((Math.random() * 1000) + 1) + "_flier_" + this.imageFile.name;

        this.imageService.uploadImage(this.imageFile, fileName, false)
            .then(data => {
                loader.dismiss();
                this.popoverActive = false;
                this.imageUrl = "https://nextgenrodeomedia.blob.core.windows.net/images/" + fileName;
            }, error => {
                loader.dismiss();
                this.popoverActive = false;
                this.alertMessager.showError("Logo Upload Error", error);
            });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/admin/texting/texting.ts